var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"justify-content":"center","display":"flex"},on:{"click":function($event){$event.stopPropagation();}}},[_c('graph-echart',{attrs:{"echartsData":_vm.echartsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }